module.exports = __webpack_public_path__ + "assets/img/qiwi.46d94389.svg";